
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import styles from '../../styles/home/securitySection.module.scss';
export default function SecuritySection() {
    return (<section className={styles.securitySection}>
      {/* Left vector group - both lines combined */}


      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Security verified By Experts. Trade With Confidence</h2>
        </div>

        <div className={styles.infoContainer}>
            <div className={styles.infoBlock}>
                <div className={styles.logoWrapper}>
                    <img src="/images/security/certik.png" alt="Certik" className={styles.logo}/>
                </div>
                <p className={styles.infoText}>Smart contract audited by Certik</p>

                    <img className={`${styles.vector} ${styles.left}`} src="/images/left_sec.svg" alt="" role="presentation"/>

            </div>

            <div className={styles.infoBlock}>
                <div className={styles.logoWrapper}>
                    <img src="/images/security/coinsult.png" alt="Coinsult" className={styles.logo}/>
                </div>
                <p className={styles.infoText}>Smart Contract audited by Coinsult</p>

                {/* Right vector group - both lines combined */}
                    <img className={`${styles.vector} ${styles.right}`} src="/images/right_sec.svg" alt="" role="presentation"/>

          </div>
        </div>
      </div>
    </section>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f51a__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//SecuritySection',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f51a__ as getStaticProps }
  